import { render, staticRenderFns } from "./SendToPitchlogForm.vue?vue&type=template&id=38078144"
import script from "./SendToPitchlogForm.vue?vue&type=script&lang=js"
export * from "./SendToPitchlogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports